import { buildFontFaceRule, collectFontWeights } from '@utils/font-face-rule';

export const COOKIE_FONT_FAMILY = 'CookieCenterCustomFont';

// One shared scope list covers every cookie modal — <style> rules apply
// globally no matter which modal's subtree hosts the tag, so each modal can
// inject the same rule and stacked/portaled modals stay covered.
export const COOKIE_FONT_SCOPES = [
  '.modal-cont.cookie-main-modal',
  '.modal-cont.cookie-preference-main-modal',
  '.modal-cont.cookie-locale-modal',
];

const HEAD_STYLE_ID = 'cookie-center-custom-font';

// fontConfig is the profile's globalConfig.font shape: { name, weights:
// [{ value: 'WEIGHT_400', url }] }. The SDK's fontConfig query param carries
// the same shape, so this is the single validation path for both sources.
export const getCookieFontWeights = (fontConfig) => collectFontWeights(
  fontConfig?.weights,
  (entry) => entry?.value,
  (entry) => entry?.url,
);

const buildCookieFontRule = (weights) => buildFontFaceRule({
  weights,
  familyName: COOKIE_FONT_FAMILY,
  scopeSelectors: COOKIE_FONT_SCOPES,
});

// Idempotently keep one <style id="cookie-center-custom-font"> in
// document.head. Head-level (rather than per-modal) so the @font-face is
// registered while the modals are still hidden — document.fonts.load() on an
// unregistered family resolves trivially and the readiness gate would open
// before the font exists. Returns the validated [{ weight, url }].
export const ensureCookieFontInjected = (fontConfig) => {
  const weights = getCookieFontWeights(fontConfig);
  if (weights.length === 0) return weights;
  const css = buildCookieFontRule(weights);
  let styleEl = document.getElementById(HEAD_STYLE_ID);
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = HEAD_STYLE_ID;
    document.head.appendChild(styleEl);
  }
  if (styleEl.textContent !== css) styleEl.textContent = css;
  return weights;
};

// cookie-center weights live on the profile's globalConfig.font.weights
// entries (value / url).
const getFontFaceRule = (profileData) => (
  buildCookieFontRule(getCookieFontWeights(profileData?.data?.globalConfig?.font))
);

export default getFontFaceRule;
